import ReferenceData from '../../refData/reference-data.js';

export const config = {
    // Name
    FIRST_NAME: { MIN: 2, MAX: 48 },
    NAME: { MIN: 2, MAX: 48 },
    SURNAME: { MIN: 2, MAX: 64 },

    // Date / Numbers
    NUMBER: { DECIMAL_POINTS: 2 },
    AGE: { MIN: 1, MAX: 999 },
    PASSPORT_NUMBER: { MIN: 6, MAX: 20 },

    // Email
    EMAIL: { MIN: 6, MAX: 200 },

    //Kenya car Reg.no
    KE_CAR_REG_NO: { MIN: 7, MAX: 7 },

    //Kenya Id
    KE_ID_NO: { MIN: 6, MAX: 8 },

    //KRA Pin number
    KRA_PIN_NO: { MIN: 11, MAX: 11 },

    // Address
    PRIVATE_BAG: { MIN: 4, MAX: 8 },

    // Account
    BANK_ACCOUNT: { MIN: 8, MAX: 11 },

    // Pronouns
    PRONOUN: { YOUR: 'your', THEIR: 'their' },

    KE_PASSPORT: { MIN: 6, MAX: 9 },
};

export const countriesConfig = {
    bw: {
        name: 'Botswana',
        countryCodePrefix: '267',
        displayCountryCodePrefix: '+267',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.botswanaCellNumberPrefixes,
        landlines: [],
    },
    za: {
        name: 'South African',
        countryCodePrefix: '27',
        displayCountryCodePrefix: '+27',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.cellNumberPrefixes,
        landlines: ReferenceData.landlinePrefixes,
    },
    mw: {
        name: 'Malawi',
        countryCodePrefix: '265',
        displayCountryCodePrefix: '+265',
        valueLength: 9,
        prefixLength: 3,
        cellNumbers: ReferenceData.malawiCellNumberPrefixes,
        landlines: [],
    },
    ss: {
        name: 'South Sudan',
        countryCodePrefix: '211',
        displayCountryCodePrefix: '+211',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.southSudanCellNumberPrefixes,
        landlines: [],
        ignorePrefix: true,
    },
    sz: {
        name: 'Eswatini',
        countryCodePrefix: '268',
        displayCountryCodePrefix: '+268',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.eswatiniCellNumberPrefixes,
        landlines: ReferenceData.eswatiniLandlinePrefixes,
    },
    zw: {
        name: 'Zimbabwe',
        countryCodePrefix: '263',
        displayCountryCodePrefix: '+263',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.zimbabweCellNumberPrefixes,
        landlines: [],
    },
    na: {
        name: 'Namibia',
        countryCodePrefix: '264',
        displayCountryCodePrefix: '+264',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.namibiaCellNumberPrefixes,
        landlines: [],
        ignorePrefix: true,
    },
    rw: {
        name: 'Rwanda',
        countryCodePrefix: '250',
        displayCountryCodePrefix: '+250',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.rwandaCellNumberPrefixes,
        landlines: ReferenceData.rwandaLandlinePrefixes,
    },
    tz: {
        name: 'Tanzania',
        countryCodePrefix: '255',
        displayCountryCodePrefix: '+255',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.tanzaniaCellNumberPrefixes,
        landlines: [],
    },
    ug: {
        name: 'Uganda',
        countryCodePrefix: '256',
        displayCountryCodePrefix: '+256',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.ugandaCellNumberPrefixes,
        landlines: [],
    },
    ke: {
        name: 'Kenya',
        countryCodePrefix: '254',
        displayCountryCodePrefix: '+254',
        valueLength: 10,
        prefixLength: 3,
        cellNumbers: ReferenceData.kenyaCellNumberPrefixes,
        landlines: [],
    },
    gh: {
        name: 'Ghana',
        countryCodePrefix: '233',
        displayCountryCodePrefix: '+233',
        valueLength: 10,
        prefixLength: 4,
        cellNumbers: ReferenceData.ghanaCellNumberPrefixes,
        landlines: [],
    },
    ng: {
        name: 'Nigeria',
        countryCodePrefix: '234',
        displayCountryCodePrefix: '+234',
        valueLength: 11,
        prefixLength: 4,
        cellNumbers: ReferenceData.nigeriaCellNumberPrefixes,
        landlines: [],
    },
    ad: {
        name: 'Andorra',
        countryCodePrefix: '376',
        displayCountryCodePrefix: '+376',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.andorraCellNumberPrefixes,
        landlines: [],
    },
    ae: {
        name: 'United Arab Emirates',
        countryCodePrefix: '971',
        displayCountryCodePrefix: '+971',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.unitedArabEmiratesCellNumberPrefixes,
        landlines: [],
    },
    af: {
        name: 'Afghanistan',
        countryCodePrefix: '93',
        displayCountryCodePrefix: '+93',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.afghanistanCellNumberPrefixes,
        landlines: [],
    },
    ag: {
        name: 'Antigua and Barbuda',
        countryCodePrefix: '1268',
        displayCountryCodePrefix: '+1268',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.antiguaAndBarbudaCellNumberPrefixes,
        landlines: [],
    },
    ai: {
        name: 'Anguilla',
        countryCodePrefix: '1264',
        displayCountryCodePrefix: '+1264',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.anguillaCellNumberPrefixes,
        landlines: [],
    },
    al: {
        name: 'Albania',
        countryCodePrefix: '355',
        displayCountryCodePrefix: '+355',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.albaniaCellNumberPrefixes,
        landlines: [],
    },
    am: {
        name: 'Armenia',
        countryCodePrefix: '374',
        displayCountryCodePrefix: '+374',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.armeniaCellNumberPrefixes,
        landlines: [],
    },
    ao: {
        name: 'Angola',
        countryCodePrefix: '244',
        displayCountryCodePrefix: '+244',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.angolaCellNumberPrefixes,
        landlines: [],
    },
    ar: {
        name: 'Argentina',
        countryCodePrefix: '54',
        displayCountryCodePrefix: '+54',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.argentinaCellNumberPrefixes,
        landlines: [],
    },
    as: {
        name: 'American Samoa',
        countryCodePrefix: '1684',
        displayCountryCodePrefix: '+1684',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.americanSamoaCellNumberPrefixes,
        landlines: [],
    },
    at: {
        name: 'Austria',
        countryCodePrefix: '43',
        displayCountryCodePrefix: '+43',
        valueLength: 13,
        prefixLength: 2,
        cellNumbers: ReferenceData.austriaCellNumberPrefixes,
        landlines: [],
    },
    au: {
        name: 'Australia',
        countryCodePrefix: '61',
        displayCountryCodePrefix: '+61',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.australiaCellNumberPrefixes,
        landlines: [],
    },
    aw: {
        name: 'Aruba',
        countryCodePrefix: '297',
        displayCountryCodePrefix: '+297',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.arubaCellNumberPrefixes,
        landlines: [],
    },
    ax: {
        name: 'Åland Islands',
        countryCodePrefix: '35818',
        displayCountryCodePrefix: '+35818',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.alandIslandsCellNumberPrefixes,
        landlines: [],
    },
    az: {
        name: 'Azerbaijan',
        countryCodePrefix: '994',
        displayCountryCodePrefix: '+994',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.azerbaijanCellNumberPrefixes,
        landlines: [],
    },
    ba: {
        name: 'Bosnia and Herzegovina',
        countryCodePrefix: '387',
        displayCountryCodePrefix: '+387',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.bosniaAndHerzegovinaCellNumberPrefixes,
        landlines: [],
    },
    bb: {
        name: 'Barbados',
        countryCodePrefix: '1246',
        displayCountryCodePrefix: '+1246',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.barbadosCellNumberPrefixes,
        landlines: [],
    },
    bd: {
        name: 'Bangladesh',
        countryCodePrefix: '880',
        displayCountryCodePrefix: '+880',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.bangladeshCellNumberPrefixes,
        landlines: [],
    },
    be: {
        name: 'Belgium',
        countryCodePrefix: '32',
        displayCountryCodePrefix: '+32',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.belgiumCellNumberPrefixes,
        landlines: [],
    },
    bf: {
        name: 'Burkina Faso',
        countryCodePrefix: '226',
        displayCountryCodePrefix: '+226',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.burkinaFasoCellNumberPrefixes,
        landlines: [],
    },
    bg: {
        name: 'Bulgaria',
        countryCodePrefix: '359',
        displayCountryCodePrefix: '+359',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.bulgariaCellNumberPrefixes,
        landlines: [],
    },
    bh: {
        name: 'Bahrain',
        countryCodePrefix: '973',
        displayCountryCodePrefix: '+973',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.bahrainCellNumberPrefixes,
        landlines: [],
    },
    bi: {
        name: 'Burundi',
        countryCodePrefix: '257',
        displayCountryCodePrefix: '+257',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.burundiCellNumberPrefixes,
        landlines: [],
    },
    bj: {
        name: 'Benin',
        countryCodePrefix: '229',
        displayCountryCodePrefix: '+229',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.beninCellNumberPrefixes,
        landlines: [],
    },
    bm: {
        name: 'Bermuda',
        countryCodePrefix: '1441',
        displayCountryCodePrefix: '+1441',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.bermudaCellNumberPrefixes,
        landlines: [],
    },
    bn: {
        name: 'Brunei Darussalam',
        countryCodePrefix: '673',
        displayCountryCodePrefix: '+673',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.bruneiDarussalamCellNumberPrefixes,
        landlines: [],
    },
    bo: {
        name: 'Bolivia (Plurinational State of)',
        countryCodePrefix: '591',
        displayCountryCodePrefix: '+591',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.boliviaPlurinationalStateOfCellNumberPrefixes,
        landlines: [],
    },
    br: {
        name: 'Brazil',
        countryCodePrefix: '55',
        displayCountryCodePrefix: '+55',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.brazilCellNumberPrefixes,
        landlines: [],
    },
    bs: {
        name: 'Bahamas',
        countryCodePrefix: '1242',
        displayCountryCodePrefix: '+1242',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.bahamasCellNumberPrefixes,
        landlines: [],
    },
    bt: {
        name: 'Bhutan',
        countryCodePrefix: '975',
        displayCountryCodePrefix: '+975',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.bhutanCellNumberPrefixes,
        landlines: [],
    },
    by: {
        name: 'Belarus',
        countryCodePrefix: '375',
        displayCountryCodePrefix: '+375',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.belarusCellNumberPrefixes,
        landlines: [],
    },
    bz: {
        name: 'Belize',
        countryCodePrefix: '501',
        displayCountryCodePrefix: '+501',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.belizeCellNumberPrefixes,
        landlines: [],
    },
    ca: {
        name: 'Canada',
        countryCodePrefix: '1',
        displayCountryCodePrefix: '+1',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.canadaCellNumberPrefixes,
        landlines: [],
    },
    cc: {
        name: 'Cocos (Keeling) Islands',
        countryCodePrefix: '61',
        displayCountryCodePrefix: '+61',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.cocosKeelingIslandsCellNumberPrefixes,
        landlines: [],
    },
    cd: {
        name: 'Congo (Democratic Republic of the)',
        countryCodePrefix: '243',
        displayCountryCodePrefix: '+243',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.congoDemocraticRepublicOfTheCellNumberPrefixes,
        landlines: [],
    },
    cf: {
        name: 'Central African Republic',
        countryCodePrefix: '236',
        displayCountryCodePrefix: '+236',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.centralAfricanRepublicCellNumberPrefixes,
        landlines: [],
    },
    cg: {
        name: 'Congo',
        countryCodePrefix: '242',
        displayCountryCodePrefix: '+242',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.congoCellNumberPrefixes,
        landlines: [],
    },
    ch: {
        name: 'Switzerland',
        countryCodePrefix: '41',
        displayCountryCodePrefix: '+41',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.switzerlandCellNumberPrefixes,
        landlines: [],
    },
    ci: {
        name: 'Côte d\'Ivoire',
        countryCodePrefix: '225',
        displayCountryCodePrefix: '+225',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.coteDIvoireCellNumberPrefixes,
        landlines: [],
    },
    ck: {
        name: 'Cook Islands',
        countryCodePrefix: '682',
        displayCountryCodePrefix: '+682',
        valueLength: 5,
        prefixLength: 1,
        cellNumbers: ReferenceData.cookIslandsCellNumberPrefixes,
        landlines: [],
    },
    cl: {
        name: 'Chile',
        countryCodePrefix: '56',
        displayCountryCodePrefix: '+56',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.chileCellNumberPrefixes,
        landlines: [],
    },
    cm: {
        name: 'Cameroon',
        countryCodePrefix: '237',
        displayCountryCodePrefix: '+237',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.cameroonCellNumberPrefixes,
        landlines: [],
    },
    cn: {
        name: 'China',
        countryCodePrefix: '86',
        displayCountryCodePrefix: '+86',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.chinaCellNumberPrefixes,
        landlines: [],
    },
    co: {
        name: 'Colombia',
        countryCodePrefix: '57',
        displayCountryCodePrefix: '+57',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.colombiaCellNumberPrefixes,
        landlines: [],
    },
    cr: {
        name: 'Costa Rica',
        countryCodePrefix: '506',
        displayCountryCodePrefix: '+506',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.costaRicaCellNumberPrefixes,
        landlines: [],
    },
    cu: {
        name: 'Cuba',
        countryCodePrefix: '53',
        displayCountryCodePrefix: '+53',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.cubaCellNumberPrefixes,
        landlines: [],
    },
    cv: {
        name: 'Cabo Verde',
        countryCodePrefix: '238',
        displayCountryCodePrefix: '+238',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.caboVerdeCellNumberPrefixes,
        landlines: [],
    },
    cx: {
        name: 'Christmas Island',
        countryCodePrefix: '61',
        displayCountryCodePrefix: '+61',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.christmasIslandCellNumberPrefixes,
        landlines: [],
    },
    cy: {
        name: 'Cyprus',
        countryCodePrefix: '357',
        displayCountryCodePrefix: '+357',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.cyprusCellNumberPrefixes,
        landlines: [],
    },
    cz: {
        name: 'Czech Republic',
        countryCodePrefix: '420',
        displayCountryCodePrefix: '+420',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.czechRepublicCellNumberPrefixes,
        landlines: [],
    },
    de: {
        name: 'Germany',
        countryCodePrefix: '49',
        displayCountryCodePrefix: '+49',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.germanyCellNumberPrefixes,
        landlines: [],
    },
    dj: {
        name: 'Djibouti',
        countryCodePrefix: '253',
        displayCountryCodePrefix: '+253',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.djiboutiCellNumberPrefixes,
        landlines: [],
    },
    dk: {
        name: 'Denmark',
        countryCodePrefix: '45',
        displayCountryCodePrefix: '+45',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.denmarkCellNumberPrefixes,
        landlines: [],
    },
    dm: {
        name: 'Dominica',
        countryCodePrefix: '1767',
        displayCountryCodePrefix: '+1767',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.dominicaCellNumberPrefixes,
        landlines: [],
    },
    do: {
        name: 'Dominican Republic',
        countryCodePrefix: '1809',
        displayCountryCodePrefix: '+1809',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.dominicanRepublicCellNumberPrefixes,
        landlines: [],
    },
    dz: {
        name: 'Algeria',
        countryCodePrefix: '213',
        displayCountryCodePrefix: '+213',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.algeriaCellNumberPrefixes,
        landlines: [],
    },
    ec: {
        name: 'Ecuador',
        countryCodePrefix: '593',
        displayCountryCodePrefix: '+593',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.ecuadorCellNumberPrefixes,
        landlines: [],
    },
    ee: {
        name: 'Estonia',
        countryCodePrefix: '372',
        displayCountryCodePrefix: '+372',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.estoniaCellNumberPrefixes,
        landlines: [],
    },
    eg: {
        name: 'Egypt',
        countryCodePrefix: '20',
        displayCountryCodePrefix: '+20',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.egyptCellNumberPrefixes,
        landlines: [],
    },
    eh: {
        name: 'Western Sahara',
        countryCodePrefix: '212',
        displayCountryCodePrefix: '+212',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.westernSaharaCellNumberPrefixes,
        landlines: [],
    },
    er: {
        name: 'Eritrea',
        countryCodePrefix: '291',
        displayCountryCodePrefix: '+291',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.eritreaCellNumberPrefixes,
        landlines: [],
    },
    es: {
        name: 'Spain',
        countryCodePrefix: '34',
        displayCountryCodePrefix: '+34',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.spainCellNumberPrefixes,
        landlines: [],
    },
    et: {
        name: 'Ethiopia',
        countryCodePrefix: '251',
        displayCountryCodePrefix: '+251',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.ethiopiaCellNumberPrefixes,
        landlines: [],
    },
    fi: {
        name: 'Finland',
        countryCodePrefix: '358',
        displayCountryCodePrefix: '+358',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.finlandCellNumberPrefixes,
        landlines: [],
    },
    fj: {
        name: 'Fiji',
        countryCodePrefix: '679',
        displayCountryCodePrefix: '+679',
        valueLength: 7,
        prefixLength: 1,
        cellNumbers: ReferenceData.fijiCellNumberPrefixes,
        landlines: [],
    },
    fk: {
        name: 'Falkland Islands (Malvinas)',
        countryCodePrefix: '500',
        displayCountryCodePrefix: '+500',
        valueLength: 5,
        prefixLength: 1,
        cellNumbers: ReferenceData.falklandIslandsMalvinasCellNumberPrefixes,
        landlines: [],
    },
    fm: {
        name: 'Micronesia (Federated States of)',
        countryCodePrefix: '691',
        displayCountryCodePrefix: '+691',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.micronesiaFederatedStatesOfCellNumberPrefixes,
        landlines: [],
    },
    fo: {
        name: 'Faroe Islands',
        countryCodePrefix: '298',
        displayCountryCodePrefix: '+298',
        valueLength: 6,
        prefixLength: 2,
        cellNumbers: ReferenceData.faroeIslandsCellNumberPrefixes,
        landlines: [],
    },
    fr: {
        name: 'France',
        countryCodePrefix: '33',
        displayCountryCodePrefix: '+33',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.franceCellNumberPrefixes,
        landlines: [],
    },
    ga: {
        name: 'Gabon',
        countryCodePrefix: '241',
        displayCountryCodePrefix: '+241',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.gabonCellNumberPrefixes,
        landlines: [],
    },
    gb: {
        name: 'United Kingdom',
        countryCodePrefix: '44',
        displayCountryCodePrefix: '+44',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.unitedKingdomCellNumberPrefixes,
        landlines: [],
    },
    gd: {
        name: 'Grenada',
        countryCodePrefix: '1473',
        displayCountryCodePrefix: '+1473',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.grenadaCellNumberPrefixes,
        landlines: [],
    },
    ge: {
        name: 'Georgia',
        countryCodePrefix: '995',
        displayCountryCodePrefix: '+995',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.georgiaCellNumberPrefixes,
        landlines: [],
    },
    gf: {
        name: 'French Guiana',
        countryCodePrefix: '594',
        displayCountryCodePrefix: '+594',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.frenchGuianaCellNumberPrefixes,
        landlines: [],
    },
    gg: {
        name: 'Guernsey',
        countryCodePrefix: '44',
        displayCountryCodePrefix: '+44',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.guernseyCellNumberPrefixes,
        landlines: [],
    },
    gi: {
        name: 'Gibraltar',
        countryCodePrefix: '350',
        displayCountryCodePrefix: '+350',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.gibraltarCellNumberPrefixes,
        landlines: [],
    },
    gl: {
        name: 'Greenland',
        countryCodePrefix: '299',
        displayCountryCodePrefix: '+299',
        valueLength: 6,
        prefixLength: 1,
        cellNumbers: ReferenceData.greenlandCellNumberPrefixes,
        landlines: [],
    },
    gm: {
        name: 'Gambia',
        countryCodePrefix: '220',
        displayCountryCodePrefix: '+220',
        valueLength: 7,
        prefixLength: 1,
        cellNumbers: ReferenceData.gambiaCellNumberPrefixes,
        landlines: [],
    },
    gn: {
        name: 'Guinea',
        countryCodePrefix: '224',
        displayCountryCodePrefix: '+224',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.guineaCellNumberPrefixes,
        landlines: [],
    },
    gp: {
        name: 'Guadeloupe',
        countryCodePrefix: '590',
        displayCountryCodePrefix: '+590',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.guadeloupeCellNumberPrefixes,
        landlines: [],
    },
    gq: {
        name: 'Equatorial Guinea',
        countryCodePrefix: '240',
        displayCountryCodePrefix: '+240',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.equatorialGuineaCellNumberPrefixes,
        landlines: [],
    },
    gr: {
        name: 'Greece',
        countryCodePrefix: '30',
        displayCountryCodePrefix: '+30',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.greeceCellNumberPrefixes,
        landlines: [],
    },
    gt: {
        name: 'Guatemala',
        countryCodePrefix: '502',
        displayCountryCodePrefix: '+502',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.guatemalaCellNumberPrefixes,
        landlines: [],
    },
    gu: {
        name: 'Guam',
        countryCodePrefix: '1671',
        displayCountryCodePrefix: '+1671',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.guamCellNumberPrefixes,
        landlines: [],
    },
    gw: {
        name: 'Guinea-Bissau',
        countryCodePrefix: '245',
        displayCountryCodePrefix: '+245',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.guineaBissauCellNumberPrefixes,
        landlines: [],
    },
    gy: {
        name: 'Guyana',
        countryCodePrefix: '592',
        displayCountryCodePrefix: '+592',
        valueLength: 7,
        prefixLength: 1,
        cellNumbers: ReferenceData.guyanaCellNumberPrefixes,
        landlines: [],
    },
    hk: {
        name: 'Hong Kong',
        countryCodePrefix: '852',
        displayCountryCodePrefix: '+852',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.hongKongCellNumberPrefixes,
        landlines: [],
    },
    hn: {
        name: 'Honduras',
        countryCodePrefix: '504',
        displayCountryCodePrefix: '+504',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.hondurasCellNumberPrefixes,
        landlines: [],
    },
    hr: {
        name: 'Croatia',
        countryCodePrefix: '385',
        displayCountryCodePrefix: '+385',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.croatiaCellNumberPrefixes,
        landlines: [],
    },
    ht: {
        name: 'Haiti',
        countryCodePrefix: '509',
        displayCountryCodePrefix: '+509',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.haitiCellNumberPrefixes,
        landlines: [],
    },
    hu: {
        name: 'Hungary',
        countryCodePrefix: '36',
        displayCountryCodePrefix: '+36',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.hungaryCellNumberPrefixes,
        landlines: [],
    },
    id: {
        name: 'Indonesia',
        countryCodePrefix: '62',
        displayCountryCodePrefix: '+62',
        valueLength: 12,
        prefixLength: 2,
        cellNumbers: ReferenceData.indonesiaCellNumberPrefixes,
        landlines: [],
    },
    ie: {
        name: 'Ireland',
        countryCodePrefix: '353',
        displayCountryCodePrefix: '+353',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.irelandCellNumberPrefixes,
        landlines: [],
    },
    il: {
        name: 'Israel',
        countryCodePrefix: '972',
        displayCountryCodePrefix: '+972',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.israelCellNumberPrefixes,
        landlines: [],
    },
    im: {
        name: 'Isle of Man',
        countryCodePrefix: '44',
        displayCountryCodePrefix: '+44',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.isleOfManCellNumberPrefixes,
        landlines: [],
    },
    in: {
        name: 'India',
        countryCodePrefix: '91',
        displayCountryCodePrefix: '+91',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.indiaCellNumberPrefixes,
        landlines: [],
    },
    io: {
        name: 'British Indian Ocean Territory',
        countryCodePrefix: '246',
        displayCountryCodePrefix: '+246',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.britishIndianOceanTerritoryCellNumberPrefixes,
        landlines: [],
    },
    iq: {
        name: 'Iraq',
        countryCodePrefix: '964',
        displayCountryCodePrefix: '+964',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.iraqCellNumberPrefixes,
        landlines: [],
    },
    ir: {
        name: 'Iran (Islamic Republic of)',
        countryCodePrefix: '98',
        displayCountryCodePrefix: '+98',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.iranIslamicRepublicOfCellNumberPrefixes,
        landlines: [],
    },
    is: {
        name: 'Iceland',
        countryCodePrefix: '354',
        displayCountryCodePrefix: '+354',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.icelandCellNumberPrefixes,
        landlines: [],
    },
    it: {
        name: 'Italy',
        countryCodePrefix: '39',
        displayCountryCodePrefix: '+39',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.italyCellNumberPrefixes,
        landlines: [],
    },
    je: {
        name: 'Jersey',
        countryCodePrefix: '44',
        displayCountryCodePrefix: '+44',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.jerseyCellNumberPrefixes,
        landlines: [],
    },
    jm: {
        name: 'Jamaica',
        countryCodePrefix: '1876',
        displayCountryCodePrefix: '+1876',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.jamaicaCellNumberPrefixes,
        landlines: [],
    },
    jo: {
        name: 'Jordan',
        countryCodePrefix: '962',
        displayCountryCodePrefix: '+962',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.jordanCellNumberPrefixes,
        landlines: [],
    },
    jp: {
        name: 'Japan',
        countryCodePrefix: '81',
        displayCountryCodePrefix: '+81',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.japanCellNumberPrefixes,
        landlines: [],
    },
    kg: {
        name: 'Kyrgyzstan',
        countryCodePrefix: '996',
        displayCountryCodePrefix: '+996',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.kyrgyzstanCellNumberPrefixes,
        landlines: [],
    },
    kh: {
        name: 'Cambodia',
        countryCodePrefix: '855',
        displayCountryCodePrefix: '+855',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.cambodiaCellNumberPrefixes,
        landlines: [],
    },
    ki: {
        name: 'Kiribati',
        countryCodePrefix: '686',
        displayCountryCodePrefix: '+686',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.kiribatiCellNumberPrefixes,
        landlines: [],
    },
    km: {
        name: 'Comoros',
        countryCodePrefix: '269',
        displayCountryCodePrefix: '+269',
        valueLength: 7,
        prefixLength: 1,
        cellNumbers: ReferenceData.comorosCellNumberPrefixes,
        landlines: [],
    },
    kn: {
        name: 'Saint Kitts and Nevis',
        countryCodePrefix: '1869',
        displayCountryCodePrefix: '+1869',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.saintKittsAndNevisCellNumberPrefixes,
        landlines: [],
    },
    kp: {
        name: 'Korea (Democratic People\'s Republic of)',
        countryCodePrefix: '82',
        displayCountryCodePrefix: '+82',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.koreaDemocraticPeopleSRepublicOfCellNumberPrefixes,
        landlines: [],
    },
    kw: {
        name: 'Kuwait',
        countryCodePrefix: '965',
        displayCountryCodePrefix: '+965',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.kuwaitCellNumberPrefixes,
        landlines: [],
    },
    ky: {
        name: 'Cayman Islands',
        countryCodePrefix: '1345',
        displayCountryCodePrefix: '+1345',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.caymanIslandsCellNumberPrefixes,
        landlines: [],
    },
    kz: {
        name: 'Kazakhstan',
        countryCodePrefix: '7',
        displayCountryCodePrefix: '+7',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.kazakhstanCellNumberPrefixes,
        landlines: [],
    },
    la: {
        name: 'Lao People\'s Democratic Republic',
        countryCodePrefix: '856',
        displayCountryCodePrefix: '+856',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.laoPeopleSDemocraticRepublicCellNumberPrefixes,
        landlines: [],
    },
    lb: {
        name: 'Lebanon',
        countryCodePrefix: '961',
        displayCountryCodePrefix: '+961',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.lebanonCellNumberPrefixes,
        landlines: [],
    },
    lc: {
        name: 'Saint Lucia',
        countryCodePrefix: '1758',
        displayCountryCodePrefix: '+1758',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.saintLuciaCellNumberPrefixes,
        landlines: [],
    },
    li: {
        name: 'Liechtenstein',
        countryCodePrefix: '423',
        displayCountryCodePrefix: '+423',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.liechtensteinCellNumberPrefixes,
        landlines: [],
    },
    lk: {
        name: 'Sri Lanka',
        countryCodePrefix: '94',
        displayCountryCodePrefix: '+94',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.sriLankaCellNumberPrefixes,
        landlines: [],
    },
    lr: {
        name: 'Liberia',
        countryCodePrefix: '231',
        displayCountryCodePrefix: '+231',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.liberiaCellNumberPrefixes,
        landlines: [],
    },
    ls: {
        name: 'Lesotho',
        countryCodePrefix: '266',
        displayCountryCodePrefix: '+266',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.lesothoCellNumberPrefixes,
        landlines: [],
    },
    lt: {
        name: 'Lithuania',
        countryCodePrefix: '370',
        displayCountryCodePrefix: '+370',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.lithuaniaCellNumberPrefixes,
        landlines: [],
    },
    lu: {
        name: 'Luxembourg',
        countryCodePrefix: '352',
        displayCountryCodePrefix: '+352',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.luxembourgCellNumberPrefixes,
        landlines: [],
    },
    lv: {
        name: 'Latvia',
        countryCodePrefix: '371',
        displayCountryCodePrefix: '+371',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.latviaCellNumberPrefixes,
        landlines: [],
    },
    ly: {
        name: 'Libya',
        countryCodePrefix: '218',
        displayCountryCodePrefix: '+218',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.libyaCellNumberPrefixes,
        landlines: [],
    },
    ma: {
        name: 'Morocco',
        countryCodePrefix: '212',
        displayCountryCodePrefix: '+212',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.moroccoCellNumberPrefixes,
        landlines: [],
    },
    mc: {
        name: 'Monaco',
        countryCodePrefix: '377',
        displayCountryCodePrefix: '+377',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.monacoCellNumberPrefixes,
        landlines: [],
    },
    md: {
        name: 'Moldova (Republic of)',
        countryCodePrefix: '373',
        displayCountryCodePrefix: '+373',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.moldovaRepublicOfCellNumberPrefixes,
        landlines: [],
    },
    me: {
        name: 'Montenegro',
        countryCodePrefix: '382',
        displayCountryCodePrefix: '+382',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.montenegroCellNumberPrefixes,
        landlines: [],
    },
    mg: {
        name: 'Madagascar',
        countryCodePrefix: '261',
        displayCountryCodePrefix: '+261',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.madagascarCellNumberPrefixes,
        landlines: [],
    },
    mh: {
        name: 'Marshall Islands',
        countryCodePrefix: '692',
        displayCountryCodePrefix: '+692',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.marshallIslandsCellNumberPrefixes,
        landlines: [],
    },
    mk: {
        name: 'Macedonia (the former Yugoslav Republic of)',
        countryCodePrefix: '389',
        displayCountryCodePrefix: '+389',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.macedoniaTheFormerYugoslavRepublicOfCellNumberPrefixes,
        landlines: [],
    },
    ml: {
        name: 'Mali',
        countryCodePrefix: '223',
        displayCountryCodePrefix: '+223',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.maliCellNumberPrefixes,
        landlines: [],
    },
    mm: {
        name: 'Myanmar',
        countryCodePrefix: '95',
        displayCountryCodePrefix: '+95',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.myanmarCellNumberPrefixes,
        landlines: [],
    },
    mn: {
        name: 'Mongolia',
        countryCodePrefix: '976',
        displayCountryCodePrefix: '+976',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.mongoliaCellNumberPrefixes,
        landlines: [],
    },
    mo: {
        name: 'Macao',
        countryCodePrefix: '853',
        displayCountryCodePrefix: '+853',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.macaoCellNumberPrefixes,
        landlines: [],
    },
    mp: {
        name: 'Northern Mariana Islands',
        countryCodePrefix: '1670',
        displayCountryCodePrefix: '+1670',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.northernMarianaIslandsCellNumberPrefixes,
        landlines: [],
    },
    mq: {
        name: 'Martinique',
        countryCodePrefix: '596',
        displayCountryCodePrefix: '+596',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.martiniqueCellNumberPrefixes,
        landlines: [],
    },
    mr: {
        name: 'Mauritania',
        countryCodePrefix: '222',
        displayCountryCodePrefix: '+222',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.mauritaniaCellNumberPrefixes,
        landlines: [],
    },
    ms: {
        name: 'Montserrat',
        countryCodePrefix: '1664',
        displayCountryCodePrefix: '+1664',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.montserratCellNumberPrefixes,
        landlines: [],
    },
    mt: {
        name: 'Malta',
        countryCodePrefix: '356',
        displayCountryCodePrefix: '+356',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.maltaCellNumberPrefixes,
        landlines: [],
    },
    mu: {
        name: 'Mauritius',
        countryCodePrefix: '230',
        displayCountryCodePrefix: '+230',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.mauritiusCellNumberPrefixes,
        landlines: [],
    },
    mv: {
        name: 'Maldives',
        countryCodePrefix: '960',
        displayCountryCodePrefix: '+960',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.maldivesCellNumberPrefixes,
        landlines: [],
    },
    mx: {
        name: 'Mexico',
        countryCodePrefix: '52',
        displayCountryCodePrefix: '+52',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.mexicoCellNumberPrefixes,
        landlines: [],
    },
    my: {
        name: 'Malaysia',
        countryCodePrefix: '60',
        displayCountryCodePrefix: '+60',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.malaysiaCellNumberPrefixes,
        landlines: [],
    },
    mz: {
        name: 'Mozambique',
        countryCodePrefix: '258',
        displayCountryCodePrefix: '+258',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.mozambiqueCellNumberPrefixes,
        landlines: [],
    },
    nc: {
        name: 'New Caledonia',
        countryCodePrefix: '687',
        displayCountryCodePrefix: '+687',
        valueLength: 6,
        prefixLength: 2,
        cellNumbers: ReferenceData.newCaledoniaCellNumberPrefixes,
        landlines: [],
    },
    ne: {
        name: 'Niger',
        countryCodePrefix: '227',
        displayCountryCodePrefix: '+227',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.nigerCellNumberPrefixes,
        landlines: [],
    },
    nf: {
        name: 'Norfolk Island',
        countryCodePrefix: '672',
        displayCountryCodePrefix: '+672',
        valueLength: 6,
        prefixLength: 2,
        cellNumbers: ReferenceData.norfolkIslandCellNumberPrefixes,
        landlines: [],
    },
    ni: {
        name: 'Nicaragua',
        countryCodePrefix: '505',
        displayCountryCodePrefix: '+505',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.nicaraguaCellNumberPrefixes,
        landlines: [],
    },
    nl: {
        name: 'Netherlands',
        countryCodePrefix: '31',
        displayCountryCodePrefix: '+31',
        valueLength: 11,
        prefixLength: 2,
        cellNumbers: ReferenceData.netherlandsCellNumberPrefixes,
        landlines: [],
    },
    no: {
        name: 'Norway',
        countryCodePrefix: '47',
        displayCountryCodePrefix: '+47',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.norwayCellNumberPrefixes,
        landlines: [],
    },
    np: {
        name: 'Nepal',
        countryCodePrefix: '977',
        displayCountryCodePrefix: '+977',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.nepalCellNumberPrefixes,
        landlines: [],
    },
    nr: {
        name: 'Nauru',
        countryCodePrefix: '674',
        displayCountryCodePrefix: '+674',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.nauruCellNumberPrefixes,
        landlines: [],
    },
    nu: {
        name: 'Niue',
        countryCodePrefix: '683',
        displayCountryCodePrefix: '+683',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.niueCellNumberPrefixes,
        landlines: [],
    },
    nz: {
        name: 'New Zealand',
        countryCodePrefix: '64',
        displayCountryCodePrefix: '+64',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.newZealandCellNumberPrefixes,
        landlines: [],
    },
    om: {
        name: 'Oman',
        countryCodePrefix: '968',
        displayCountryCodePrefix: '+968',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.omanCellNumberPrefixes,
        landlines: [],
    },
    pa: {
        name: 'Panama',
        countryCodePrefix: '507',
        displayCountryCodePrefix: '+507',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.panamaCellNumberPrefixes,
        landlines: [],
    },
    pe: {
        name: 'Peru',
        countryCodePrefix: '51',
        displayCountryCodePrefix: '+51',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.peruCellNumberPrefixes,
        landlines: [],
    },
    pf: {
        name: 'French Polynesia',
        countryCodePrefix: '689',
        displayCountryCodePrefix: '+689',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.frenchPolynesiaCellNumberPrefixes,
        landlines: [],
    },
    pg: {
        name: 'Papua New Guinea',
        countryCodePrefix: '675',
        displayCountryCodePrefix: '+675',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.papuaNewGuineaCellNumberPrefixes,
        landlines: [],
    },
    ph: {
        name: 'Philippines',
        countryCodePrefix: '63',
        displayCountryCodePrefix: '+63',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.philippinesCellNumberPrefixes,
        landlines: [],
    },
    pk: {
        name: 'Pakistan',
        countryCodePrefix: '92',
        displayCountryCodePrefix: '+92',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.pakistanCellNumberPrefixes,
        landlines: [],
    },
    pl: {
        name: 'Poland',
        countryCodePrefix: '48',
        displayCountryCodePrefix: '+48',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.polandCellNumberPrefixes,
        landlines: [],
    },
    pm: {
        name: 'Saint Pierre and Miquelon',
        countryCodePrefix: '508',
        displayCountryCodePrefix: '+508',
        valueLength: 6,
        prefixLength: 2,
        cellNumbers: ReferenceData.saintPierreAndMiquelonCellNumberPrefixes,
        landlines: [],
    },
    pr: {
        name: 'Puerto Rico',
        countryCodePrefix: '1787',
        displayCountryCodePrefix: '+1787',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.puertoRicoCellNumberPrefixes,
        landlines: [],
    },
    ps: {
        name: 'Palestine, State of',
        countryCodePrefix: '970',
        displayCountryCodePrefix: '+970',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.palestineStateOfCellNumberPrefixes,
        landlines: [],
    },
    pt: {
        name: 'Portugal',
        countryCodePrefix: '351',
        displayCountryCodePrefix: '+351',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.portugalCellNumberPrefixes,
        landlines: [],
    },
    pw: {
        name: 'Palau',
        countryCodePrefix: '680',
        displayCountryCodePrefix: '+680',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.palauCellNumberPrefixes,
        landlines: [],
    },
    py: {
        name: 'Paraguay',
        countryCodePrefix: '595',
        displayCountryCodePrefix: '+595',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.paraguayCellNumberPrefixes,
        landlines: [],
    },
    qa: {
        name: 'Qatar',
        countryCodePrefix: '974',
        displayCountryCodePrefix: '+974',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.qatarCellNumberPrefixes,
        landlines: [],
    },
    re: {
        name: 'Réunion',
        countryCodePrefix: '262',
        displayCountryCodePrefix: '+262',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.reunionCellNumberPrefixes,
        landlines: [],
    },
    ro: {
        name: 'Romania',
        countryCodePrefix: '40',
        displayCountryCodePrefix: '+40',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.romaniaCellNumberPrefixes,
        landlines: [],
    },
    rs: {
        name: 'Serbia',
        countryCodePrefix: '381',
        displayCountryCodePrefix: '+381',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.serbiaCellNumberPrefixes,
        landlines: [],
    },
    ru: {
        name: 'Russian Federation',
        countryCodePrefix: '7',
        displayCountryCodePrefix: '+7',
        valueLength: 10,
        prefixLength: 1,
        cellNumbers: ReferenceData.russianFederationCellNumberPrefixes,
        landlines: [],
    },
    sa: {
        name: 'Saudi Arabia',
        countryCodePrefix: '966',
        displayCountryCodePrefix: '+966',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.saudiArabiaCellNumberPrefixes,
        landlines: [],
    },
    sb: {
        name: 'Solomon Islands',
        countryCodePrefix: '677',
        displayCountryCodePrefix: '+677',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.solomonIslandsCellNumberPrefixes,
        landlines: [],
    },
    sc: {
        name: 'Seychelles',
        countryCodePrefix: '248',
        displayCountryCodePrefix: '+248',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.seychellesCellNumberPrefixes,
        landlines: [],
    },
    sd: {
        name: 'Sudan',
        countryCodePrefix: '249',
        displayCountryCodePrefix: '+249',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.sudanCellNumberPrefixes,
        landlines: [],
    },
    se: {
        name: 'Sweden',
        countryCodePrefix: '46',
        displayCountryCodePrefix: '+46',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.swedenCellNumberPrefixes,
        landlines: [],
    },
    sg: {
        name: 'Singapore',
        countryCodePrefix: '65',
        displayCountryCodePrefix: '+65',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.singaporeCellNumberPrefixes,
        landlines: [],
    },
    sh: {
        name: 'Saint Helena, Ascension and Tristan da Cunha',
        countryCodePrefix: '290',
        displayCountryCodePrefix: '+290',
        valueLength: 5,
        prefixLength: 1,
        cellNumbers: ReferenceData.saintHelenaAscensionAndTristanDaCunhaCellNumberPrefixes,
        landlines: [],
    },
    si: {
        name: 'Slovenia',
        countryCodePrefix: '386',
        displayCountryCodePrefix: '+386',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.sloveniaCellNumberPrefixes,
        landlines: [],
    },
    sj: {
        name: 'Svalbard and Jan Mayen',
        countryCodePrefix: '47',
        displayCountryCodePrefix: '+47',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.svalbardAndJanMayenCellNumberPrefixes,
        landlines: [],
    },
    sk: {
        name: 'Slovakia',
        countryCodePrefix: '421',
        displayCountryCodePrefix: '+421',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.slovakiaCellNumberPrefixes,
        landlines: [],
    },
    sl: {
        name: 'Sierra Leone',
        countryCodePrefix: '232',
        displayCountryCodePrefix: '+232',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.sierraLeoneCellNumberPrefixes,
        landlines: [],
    },
    sm: {
        name: 'San Marino',
        countryCodePrefix: '378',
        displayCountryCodePrefix: '+378',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.sanMarinoCellNumberPrefixes,
        landlines: [],
    },
    sn: {
        name: 'Senegal',
        countryCodePrefix: '221',
        displayCountryCodePrefix: '+221',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.senegalCellNumberPrefixes,
        landlines: [],
    },
    so: {
        name: 'Somalia',
        countryCodePrefix: '252',
        displayCountryCodePrefix: '+252',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.somaliaCellNumberPrefixes,
        landlines: [],
    },
    sr: {
        name: 'Suriname',
        countryCodePrefix: '597',
        displayCountryCodePrefix: '+597',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.surinameCellNumberPrefixes,
        landlines: [],
    },
    st: {
        name: 'Sao Tome and Principe',
        countryCodePrefix: '239',
        displayCountryCodePrefix: '+239',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.saoTomeAndPrincipeCellNumberPrefixes,
        landlines: [],
    },
    sv: {
        name: 'El Salvador',
        countryCodePrefix: '503',
        displayCountryCodePrefix: '+503',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.elSalvadorCellNumberPrefixes,
        landlines: [],
    },
    sy: {
        name: 'Syrian Arab Republic',
        countryCodePrefix: '963',
        displayCountryCodePrefix: '+963',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.syrianArabRepublicCellNumberPrefixes,
        landlines: [],
    },
    tc: {
        name: 'Turks and Caicos Islands',
        countryCodePrefix: '1649',
        displayCountryCodePrefix: '+1649',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.turksAndCaicosIslandsCellNumberPrefixes,
        landlines: [],
    },
    td: {
        name: 'Chad',
        countryCodePrefix: '235',
        displayCountryCodePrefix: '+235',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.chadCellNumberPrefixes,
        landlines: [],
    },
    tg: {
        name: 'Togo',
        countryCodePrefix: '228',
        displayCountryCodePrefix: '+228',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.togoCellNumberPrefixes,
        landlines: [],
    },
    th: {
        name: 'Thailand',
        countryCodePrefix: '66',
        displayCountryCodePrefix: '+66',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.thailandCellNumberPrefixes,
        landlines: [],
    },
    tj: {
        name: 'Tajikistan',
        countryCodePrefix: '992',
        displayCountryCodePrefix: '+992',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.tajikistanCellNumberPrefixes,
        landlines: [],
    },
    tk: {
        name: 'Tokelau',
        countryCodePrefix: '690',
        displayCountryCodePrefix: '+690',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.tokelauCellNumberPrefixes,
        landlines: [],
    },
    tl: {
        name: 'Timor-Leste',
        countryCodePrefix: '670',
        displayCountryCodePrefix: '+670',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.timorLesteCellNumberPrefixes,
        landlines: [],
    },
    tm: {
        name: 'Turkmenistan',
        countryCodePrefix: '993',
        displayCountryCodePrefix: '+993',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.turkmenistanCellNumberPrefixes,
        landlines: [],
    },
    tn: {
        name: 'Tunisia',
        countryCodePrefix: '216',
        displayCountryCodePrefix: '+216',
        valueLength: 8,
        prefixLength: 1,
        cellNumbers: ReferenceData.tunisiaCellNumberPrefixes,
        landlines: [],
    },
    to: {
        name: 'Tonga',
        countryCodePrefix: '676',
        displayCountryCodePrefix: '+676',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.tongaCellNumberPrefixes,
        landlines: [],
    },
    tr: {
        name: 'Turkey',
        countryCodePrefix: '90',
        displayCountryCodePrefix: '+90',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.turkeyCellNumberPrefixes,
        landlines: [],
    },
    tt: {
        name: 'Trinidad and Tobago',
        countryCodePrefix: '1868',
        displayCountryCodePrefix: '+1868',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.trinidadAndTobagoCellNumberPrefixes,
        landlines: [],
    },
    tv: {
        name: 'Tuvalu',
        countryCodePrefix: '688',
        displayCountryCodePrefix: '+688',
        valueLength: 7,
        prefixLength: 2,
        cellNumbers: ReferenceData.tuvaluCellNumberPrefixes,
        landlines: [],
    },
    tw: {
        name: 'Taiwan, Province of China',
        countryCodePrefix: '886',
        displayCountryCodePrefix: '+886',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.taiwanProvinceOfChinaCellNumberPrefixes,
        landlines: [],
    },
    ua: {
        name: 'Ukraine',
        countryCodePrefix: '380',
        displayCountryCodePrefix: '+380',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.ukraineCellNumberPrefixes,
        landlines: [],
    },
    us: {
        name: 'United States of America',
        countryCodePrefix: '1',
        displayCountryCodePrefix: '+1',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.unitedStatesOfAmericaCellNumberPrefixes,
        landlines: [],
    },
    uy: {
        name: 'Uruguay',
        countryCodePrefix: '598',
        displayCountryCodePrefix: '+598',
        valueLength: 8,
        prefixLength: 2,
        cellNumbers: ReferenceData.uruguayCellNumberPrefixes,
        landlines: [],
    },
    uz: {
        name: 'Uzbekistan',
        countryCodePrefix: '998',
        displayCountryCodePrefix: '+998',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.uzbekistanCellNumberPrefixes,
        landlines: [],
    },
    vc: {
        name: 'Saint Vincent and the Grenadines',
        countryCodePrefix: '1784',
        displayCountryCodePrefix: '+1784',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.saintVincentAndTheGrenadinesCellNumberPrefixes,
        landlines: [],
    },
    ve: {
        name: 'Venezuela (Bolivarian Republic of)',
        countryCodePrefix: '58',
        displayCountryCodePrefix: '+58',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.venezuelaBolivarianRepublicOfCellNumberPrefixes,
        landlines: [],
    },
    vg: {
        name: 'Virgin Islands (British)',
        countryCodePrefix: '1284',
        displayCountryCodePrefix: '+1284',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.virginIslandsBritishCellNumberPrefixes,
        landlines: [],
    },
    vi: {
        name: 'Virgin Islands (U.S.)',
        countryCodePrefix: '1340',
        displayCountryCodePrefix: '+1340',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.virginIslandsUsCellNumberPrefixes,
        landlines: [],
    },
    vn: {
        name: 'Viet Nam',
        countryCodePrefix: '84',
        displayCountryCodePrefix: '+84',
        valueLength: 9,
        prefixLength: 1,
        cellNumbers: ReferenceData.vietNamCellNumberPrefixes,
        landlines: [],
    },
    vu: {
        name: 'Vanuatu',
        countryCodePrefix: '678',
        displayCountryCodePrefix: '+678',
        valueLength: 7,
        prefixLength: 1,
        cellNumbers: ReferenceData.vanuatuCellNumberPrefixes,
        landlines: [],
    },
    wf: {
        name: 'Wallis and Futuna',
        countryCodePrefix: '681',
        displayCountryCodePrefix: '+681',
        valueLength: 6,
        prefixLength: 2,
        cellNumbers: ReferenceData.wallisAndFutunaCellNumberPrefixes,
        landlines: [],
    },
    ws: {
        name: 'Samoa',
        countryCodePrefix: '685',
        displayCountryCodePrefix: '+685',
        valueLength: 10,
        prefixLength: 2,
        cellNumbers: ReferenceData.samoaCellNumberPrefixes,
        landlines: [],
    },
    ye: {
        name: 'Yemen',
        countryCodePrefix: '967',
        displayCountryCodePrefix: '+967',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.yemenCellNumberPrefixes,
        landlines: [],
    },
    yt: {
        name: 'Mayotte',
        countryCodePrefix: '262',
        displayCountryCodePrefix: '+262',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.mayotteCellNumberPrefixes,
        landlines: [],
    },
    zm: {
        name: 'Zambia',
        countryCodePrefix: '260',
        displayCountryCodePrefix: '+260',
        valueLength: 9,
        prefixLength: 2,
        cellNumbers: ReferenceData.zambiaCellNumberPrefixes,
        landlines: [],
    },
};

export const DEFAULT_COUNTRY_CODE = 'za';

function getCountryCodes() {
    return Object.keys(countriesConfig).map((cCode) => ({
        countryCode: countriesConfig[cCode].displayCountryCodePrefix,
        displayName: countriesConfig[cCode].name,
    }));
}

export const countryCodeList = getCountryCodes();
